export default __webpack_public_path__ + "static/media/saNFT.7446a6ff.png";